import React from 'react'
import BlogIso from './BlogIso'
import { useSelector } from 'react-redux'
import LoderBlogIso from './LoderBlogIso'
import { selectBlogList } from '../../reducers/resumeSlice'
import BlogIsotope from './BlogIsotope'

export default function Blog() {
    const blogInfo = useSelector(selectBlogList)
    // console.log(blogInfo);

    return (
        <section data-id="blog" className="animated-section blog">
            {/* start section-content  */}
            <div className="section-content">
                <div className="page-title">
                    <h2>وبلاگ</h2>
                    <h4>لورم ایپسوم</h4>
                </div>

                {/* {blogInfo !== null ? <BlogIso weblogInfo={blogInfo} /> : <LoderBlogIso />} */}
                {blogInfo !== null ? <BlogIsotope weblogInfo={blogInfo} /> : <LoderBlogIso />}

            </div>
        </section>
    )
}
